import React from 'react'
import { useState,useEffect } from 'react'

import Item from './item'
import MobileItem from './mobileItem'
import Searchbar from '../../../components/forms/searchbar'
import ScreenSizes from '../../../configTools/screenSizes'
import Get from '../../../functions/dashboard/order'

const Index = () => {
  const [Navigation,setNavigation] = useState([]);
  const [FilterNavigation,setFilterNavigation] = useState(Navigation);
  const width = window.innerWidth;
  function filterFunction(value){
    if(value === ""){
      setFilterNavigation(Navigation);
    }
    else{
      const filtedNavigation = Navigation.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setFilterNavigation(filtedNavigation);
    }
  }
  useEffect(() => {
    Get((res)=>{
      setNavigation(res);
      setFilterNavigation(res);
    });
  },[])
  return (
      <div className='form_table_container'>
        <Searchbar Filter={filterFunction}/>
        {width > ScreenSizes.Mobile &&
          <>
            <div className='form_item_row_container title'>
              <div className='form_item_row_container_itemfull' style={{width:'16%'}}>
                <p>Order#</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'14%'}}>
                <p>Fulfilment Status</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'14%'}}>
                <p>Payment</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'14%'}}>
                <p>Net Total</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'14%'}}>
                <p>Kaay Commission</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'14%'}}>
                <p>Shipping</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'14%'}}>
                <p>Payables</p>
              </div>
            </div>
            {
              FilterNavigation.map((item)=>{
                return(
                  <Item Obj = {item} key={item.id} />
                );
              })
            }
          </>
        }
        {width <= ScreenSizes.Mobile &&
          <>
          {
            FilterNavigation.map((item)=>{
              return(
                <MobileItem Obj = {item} key={item.id} />
              );
            })
          }
          </>
        }
      </div>
  )
}

export default Index
